import { render } from "./PropertyFilter.vue?vue&type=template&id=373c43c0&ts=true"
import script from "./PropertyFilter.vue?vue&type=script&lang=ts"
export * from "./PropertyFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__